import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-warn",
  "use": "icon-warn-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-warn\">\r\n  <defs>\r\n    <style>\r\n      #icon-warn .cls-1 {\r\n        fill: #ffa940;\r\n      }\r\n\r\n      #icon-warn .cls-2 {\r\n        fill: #fff;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <circle id=\"icon-warn_椭圆_987\" data-name=\"椭圆 987\" class=\"cls-1\" cx=\"10\" cy=\"10\" r=\"10\" />\r\n  <rect id=\"icon-warn_圆角矩形_1491\" data-name=\"圆角矩形 1491\" class=\"cls-2\" x=\"4\" y=\"9\" width=\"12\" height=\"2\" rx=\"1\" ry=\"1\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/warn.svg
// module id = a5SC
// module chunks = 127